<script>
import { warehouseMethods, inventoryMethods } from '@state/helpers'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
let _ = require('lodash')

export default {
  name: 'MultiSelectWarehouse',
  components: { Multiselect },
    props: {
    label_cols_xl: {
      type: Number,
      required: false,
      default: 3,
    },
    content_cols_xl: {
      type: Number,
      required: false,
      default: 9,
    },
    onlyWithLocations: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      select_warehouse: null,
      select_ubication: null,
    }
  },
  computed: {
    ...mapGetters({
      loading_warehouses: 'retina/warehouse/loading_warehouses',
      warehouses: 'retina/warehouse/warehouses',
      // warehouse_selected: 'retina/warehouse/warehouse_selected',
      // ubication_selected: 'retina/warehouse/ubication_selected',
    }),
    warehouse_selected: {
      get: function() {
          return this.$store.getters['retina/warehouse/warehouse_selected']
      },
      set: function(value) {
          this.$store.dispatch('retina/warehouse/selectWarehouse', value)
      }
    },
    ubication_selected: {
      get: function() {
          return this.$store.getters['retina/warehouse/ubication_selected']
      },
      set: function(value) {
          this.$store.dispatch('retina/warehouse/selectUbication', value)
      }
    },
    ubications() {
      return this.warehouse_selected ? this.warehouse_selected.ubications : []
    },
  },
  methods: {
    ...warehouseMethods,
    ...inventoryMethods,
    allWarehouse() {
      this.setLoadingWarehouses(true)
      return this.fetchWarehouses(this.onlyWithLocations ? '?only_with_locations=true' : null)
        .then((data) => {
          this.setWarehouses(data.results)
          this.setLoadingWarehouses(false)
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          this.setWarehouses([])
          this.setLoadingWarehouses(false)
          return []
        })
    },
    selectWarehouseProccess() {
      this.selectWarehouse(this.select_warehouse)
      this.select_ubication = null
      this.clearUbication()
    },
  },
  mounted() {
    this.allWarehouse()    
    this.select_warehouse = this.warehouse_selected
      ? _.cloneDeep(this.warehouse_selected)
      : null
    this.select_ubication = this.ubication_selected
      ? _.cloneDeep(this.ubication_selected)
      : null
  },
  watch: {
    warehouse_selected: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.select_warehouse = _.cloneDeep(val) || null
      }
    },
  },
}
</script>

<template>
  <div>
    <b-row class="pt-2 pb-0 pl-1">
      <b-col lg="6" md="12" >
        <b-form-group
          label="Bodegas"
          :label-cols-xl="label_cols_xl"
          :content-cols-xl="content_cols_xl"
        >
          <Multiselect
            v-if="warehouses && Object.keys(warehouses).length > 0"
            v-model="select_warehouse"
            :options="warehouses"
            placeholder="Seleccione una Bodega"
            label="description"
            track-by="description"
            @input="selectWarehouseProccess()"
            selectLabel="+"
            deselectLabel="×"
            selectedLabel="✔︎"
            :loading="loading_warehouses"
          >
          </Multiselect>

          <div v-if="loading_warehouses">
            <p class="p-2 text-info">
              <!-- <span class="spinner-border spinner-border-sm text-info" small role="status"></span> -->
              <span class="spinner-border" small role="status"></span> Cargando lista de bodegas
            </p>
          </div>
        </b-form-group>
      </b-col>
      <b-col lg="6" md="12">
        <b-form-group
          v-if="ubications.length"
          label="Ubicaciones"
          :label-cols-xl="label_cols_xl"
          :content-cols-xl="content_cols_xl"
        >
          <Multiselect
            v-if="ubications && Object.keys(ubications).length > 0"
            v-model="select_ubication"
            :options="ubications"
            placeholder="Seleccione una ubicación"
            label="name"
            track-by="name"
            @input="selectUbication(select_ubication)"
            selectLabel="+"
            deselectLabel="×"
            selectedLabel=✔︎
            :loading="loading_warehouses"
          >
          </Multiselect>
          <div v-if="loading_warehouses">
            <p class="p-2 text-info">
              <span class="spinner-border" role="status"></span> Cargando lista de ubicaciones
            </p>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
